// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2d263012","169":"ced227b4","302":"05e44baa","400":"f12b4bdc"}[chunkId] + ".chunk.js";
};